'use strict';

/*global Container */
/*global WinsWindow */
/*global WinsModal */
/*global WinsConfirm */
/*global Translator */
/*global Configurations */
/*global DevelopmentTools */
/*global Notifications */
/*global MyProfile */
/*global PageIntro */

var services = new Container();

$(document).bind('pageLoaded', function () {
    services.set('window', new WinsWindow());
    services.set('configurations', new Configurations('configurations'));
    services.set('translator', new Translator('translations'));
    services.set('development', new DevelopmentTools());
    services.set('notifications', new Notifications());
    services.set('modal', new WinsModal('wins-modal'));
    services.set('confirm', new WinsConfirm('wins-confirm'));
    services.set('modal-message', new WinsModal('wins-modal-message'));
    services.set('my-profile', new MyProfile());
    services.set('page-intro', new PageIntro('page-intro'));

    $(document).trigger('configurationLoaded');
    $(document).trigger('documentReady');
});
